import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import InlineAttachmentStatus from 'owa-attachment-full-data/lib/schema/InlineAttachmentStatus';
import AttachmentUrlType from 'owa-files-url/lib/schema/AttachmentUrlType';
import { mutatorAction } from 'satcheljs';
import {
    AttachmentFullViewState,
    AttachmentState,
    InlineAttachmentState,
    createInlineAttachmentState,
} from 'owa-attachment-full-data';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import { getAttachmentUrlForClassic } from 'owa-attachment-url';

export default mutatorAction(
    'convertImageViewAttachmentToInlineAttachment',
    function convertImageViewAttachmentToInlineAttachment(
        attachmentWell: AttachmentWellViewState,
        attachment: AttachmentFullViewState,
        contentId: string
    ) {
        const attachmentModel = getAttachment(attachment.attachmentId);

        if (!attachmentModel) {
            return;
        }

        const imageViewAttachments: AttachmentState[] = attachmentWell.imageViewAttachments;
        const inlineAttachments: InlineAttachmentState[] = attachmentWell.inlineAttachments;

        const targetIndex = imageViewAttachments.indexOf(attachment);
        if (targetIndex >= 0) {
            // Remove attachment from the imageViewAttachments collection.
            imageViewAttachments.splice(targetIndex, 1);

            // Update attachment model
            attachmentModel.model.ContentId = contentId;
            attachmentModel.model.IsInline = true;

            attachmentModel.model.AttachmentOriginalUrl = getAttachmentUrlForClassic(
                attachment.attachmentId,
                AttachmentUrlType.Preview
            );

            // Update store to mark that the attachment is now inline
            const inlineAttachment: InlineAttachmentState = createInlineAttachmentState(
                attachment.attachmentId,
                attachment.attachmentId.Id,
                false /* isHiddenInline */
            );

            inlineAttachment.status = InlineAttachmentStatus.ConvertAttachmentInlineSucceeded;
            inlineAttachments.push(inlineAttachment);
        }
    }
);
